
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface CustomerBasicInfoProps {
  name: string;
  setName: (name: string) => void;
  email: string;
  setEmail: (email: string) => void;
  phone: string;
  setPhone: (phone: string) => void;
  errors: Record<string, string>;
  saving: boolean;
}

const CustomerBasicInfo = ({
  name,
  setName,
  email,
  setEmail,
  phone,
  setPhone,
  errors,
  saving
}: CustomerBasicInfoProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="name">Nom <span className="text-red-500">*</span></Label>
        <Input
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nom du client"
          disabled={saving}
        />
        {errors.name && <p className="text-sm text-red-500">{errors.name}</p>}
      </div>

      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={email || ''}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="email@example.com"
          disabled={saving}
        />
        {errors.email && <p className="text-sm text-red-500">{errors.email}</p>}
      </div>

      <div className="space-y-2">
        <Label htmlFor="phone">Téléphone <span className="text-red-500">*</span></Label>
        <Input
          id="phone"
          value={phone || ''}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="+33 6 12 34 56 78"
          disabled={saving}
        />
        {errors.phone && <p className="text-sm text-red-500">{errors.phone}</p>}
      </div>
    </>
  );
};

export default CustomerBasicInfo;
